export default __webpack_public_path__ + "static/media/logo.5c68c5ee.svg";